export default function ($translate) {
    return {
        KEYS: {
            COMPLETE: 'COMPLETE',
            INCOMPLETE: 'INCOMPLETE'
        },
        LABELS: {
            COMPLETE: $translate.instant('course.complete'),
            INCOMPLETE: $translate.instant('course.incomplete')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/status/index.js